export default __webpack_public_path__ + "static/8-of-the-best-cruises-in-the-world-alaska-f7edb21cddbcb5cb933b7c7cd5562d22.jpg";